// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3m6g5","title":"FrontImage_title__1CXkb"};